import { orderBy } from 'lodash/collection';
import { isArray, isEmpty } from 'lodash/lang';

import LogTableApi from '../../../../../../api/patient/LogTableApi';

export function loadLogRecords(ssuPatientId, patientItemGroupId, showLogCheck, filterByStatuses) {
  return (function() {
    if (showLogCheck) {
      return LogTableApi.getLogTableWithLogCheck({
        ssuPatient: ssuPatientId,
        itemGroupId: patientItemGroupId
      });
    }

    return LogTableApi.getLogTable({
      ssuPatient: ssuPatientId,
      itemGroupTemplateId: patientItemGroupId
    });
  })().then(({ data }) => prepareLogRecords(data));

  function prepareLogRecords({ logData }) {
    const orderedRecords = orderBy(logData.tableData, 'logRowNumber', 'desc');
    const preparedRecords = orderedRecords.map(record => {
      return { ...record, aeStatus: logData?.logRowStatuses[record.rowId] };
    });

    if (isEmpty(filterByStatuses) || !isArray(filterByStatuses)) {
      return preparedRecords;
    }

    return preparedRecords.filter(({ aeStatus }) => filterByStatuses.includes(aeStatus));
  }
}
